/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "GetNet's Portfolio",
  description:
    " I'm a research intern at University of Oulu, pursuing three joint master's degrees in IMAGE PROCESSING and COMPUTER VISION from University of Bordeaux-France, Autonmous University of Madrid-Spain and Pázmány Péter Catholic University-Hungary.",
  og: {
    title: "Getnet Demil Portfolio",
    type: "website",
    url: "http://getnetdemil.github.io/",
  },
};

//Home Page
const greeting = {
  title: "GetNet Demil",
  logo_name: "GetNet Demil",
  nickname: "የያጤነሽ ልጅ - Yatenesh's Son",
  subTitle:
    "Doctoral Researcher (Ph.D) at University of Oulu.  Triple MS.c holder in IPCV from UBx-France, UAM-Spain and PPKE-Hungary.",
  resumeLink:
    // "https://getnetdemil.github.io/skills/Getnet_Demil_Resume.pdf",
    "https://flowcv.com/resume/pwg1rj0mti",
  portfolio_repository: "https://www.linkedin.com/in/getnetdemil/",
  githubProfile: "https://github.com/getnetdemil",
  // displayGreeting: true // Set false to hide this section, defaults to true
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/getnetdemil",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/getnetdemil/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://youtube.com/c/getnetdemil",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:getnetd24@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://twitter.com/getnetdemil",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/GetnetGrayHat/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/getnet_demil_jr/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Tiktok",
    link: "https://www.tiktok.com/gech_jr/",
    fontAwesomeIcon: "fa-tiktok", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "I can speak",
      fileName: "DataScienceImg",
      skills: [
        // "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        // "⚡ Experience of working with Computer Vision and NLP projects",
        // "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "devicon-cplusplus",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Matlab",
          fontAwesomeClassname: "devicon-matlab",
          style: {
            backgroundColor: "transparent",
            // color: "#D00000",
          },
        },
      ],
    },
    {
      title: "Frameworks",
      fileName: "FullStackImg",
      skills: [
        // "⚡ Building responsive website front end using React-Redux",
        // "⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin",
        // "⚡ Creating application backend in Node, Express & Flask",
      ],
      softwareSkills: [

        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
        
        {
          skillName: "Keras",
          fontAwesomeClassname: "devicon-keras",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "devicon-opencv",
          style: {
            backgroundColor: "transparent",

          },
        },
        {
          skillName: "Scikit-learn",
          fontAwesomeClassname: "devicon-scikitlearn",
          style: {
            backgroundColor: "transparent",

          },
        },
        {
          skillName: "Matplotlib",
          fontAwesomeClassname: "devicon-matplotlib",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Numpy",
          fontAwesomeClassname: "devicon-numpy",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "devicon-pandas",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Pillow",
          imageSrc: "pillow.png",
        },
        {
          skillName: "Skimage",
          imageSrc: "skimage.png",

        },
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Tools",
      fileName: "CloudInfraImg",
      skills: [
        // "⚡ Experience working on multiple cloud platforms",
        // "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        // "⚡ Deploying deep learning models on cloud to use on mobile devices",
        // "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "Latex",
          fontAwesomeClassname: "devicon-latex",
        style: {
          backgroundColor: "transparent",
          },
        },
        {
          skillName: "VScode",
          fontAwesomeClassname: "devicon-vscode",
          style: {
            backgroundColor: "transparent",

          },
        },
        {
          skillName: "Anaconda",
          fontAwesomeClassname: "devicon-anaconda",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Colab",
          fontAwesomeClassname: "simple-icons:googlecolab",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Jupyter",
          fontAwesomeClassname: "devicon-jupyter",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "devicon-git",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Kaggle",
          fontAwesomeClassname: "devicon-kaggle",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "OptiSystem",
          imageSrc: "opti.png",
        },
        {
          skillName: "SAP ERP",
          fontAwesomeClassname: "logos:sap",
          style: {
            color: "#1488C6",
          },
        },

      ],
    },
    {
      title: "Awards",
      fileName: "DesignImg",
      skills: [
        "⚡ Erasmus+ Grante, 2023-24",
        "⚡ IPCV Excellence Scholarship, 2022",
        "⚡ African Top 50 Project of The Year, 2019",
        "⚡ Bahir Dar University Best Project of The Year, 2018",
        
      ],
      softwareSkills: [
        {
          skillName: "Erasmus+ Grant",
          imageSrc: "ipcv.png",
        },
        {
          skillName: "IPCV Excellence Scholarship",
          // fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "African Top 50 Project of The Year, 2019",
          imageSrc: "au.png",

        },
        {
          skillName: "Bahir Dar University Best Project of The Year, 2018",
          imageSrc: "bdu.png",
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
   {
      siteName: "Finland",
      iconifyClassname: "twemoji:flag-finland",
      style: {
        backgroundColor: "transparent",
      },
      // profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "France",
      iconifyClassname: "twemoji:flag-france",
      style: {
        backgroundColor: "transparent",
      },
      // profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "Spain",
      iconifyClassname: "twemoji:flag-spain",
      style: {
        backgroundColor: "transparent",
      },
      // profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "Hungary",
      iconifyClassname: "twemoji:flag-hungary",
      style: {
        backgroundColor: "transparent",
      },
      // profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "Ethiopia",
      iconifyClassname: "twemoji:flag-ethiopia",
      style: {
        backgroundColor: "transparent",
      },
      // profileLink: "https://leetcode.com/layman_brother/",
    },
    // {
    //   siteName: "HackerRank",
    //   iconifyClassname: "simple-icons:hackerrank",
    //   style: {
    //     color: "#2EC866",
    //   },
    //   profileLink: "https://www.hackerrank.com/layman_brother",
    // },
    // {
    //   siteName: "Codechef",
    //   iconifyClassname: "simple-icons:codechef",
    //   style: {
    //     color: "#5B4638",
    //   },
    //   profileLink: "https://www.codechef.com/users/ashutosh_1919",
    // },
    // {
    //   siteName: "Codeforces",
    //   iconifyClassname: "simple-icons:codeforces",
    //   style: {
    //     color: "#1F8ACB",
    //   },
    //   profileLink: "http://codeforces.com/profile/layman_brother",
    // },
    // {
    //   siteName: "Hackerearth",
    //   iconifyClassname: "simple-icons:hackerearth",
    //   style: {
    //     color: "#323754",
    //   },
    //   profileLink: "https://www.hackerearth.com/@ashutosh391",
    // },
    // {
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF",
    //   },
    //   profileLink: "https://www.kaggle.com/laymanbrother",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Oulu - Finland",
      subtitle: "PhD in Artificial Intelligence and Remote Sensing Technology for Hydrology Model",
      logo_path: "uoulu.png",
      alt_name: "UnivOULU",
      duration: "2024 - Present",
      descriptions: [
        "⚡ Hydrology Parameter Estimation",
        "⚡ Snow Hydrology Parameter Estimation",
      ],
      website_link: "https://www.oulu.fi",
    },
    {
      title: "University of Bordeaux - France",
      subtitle: "M.Sc. in Image Processing and Computer Vision",
      logo_path: "ub.png",
      alt_name: "UBx",
      duration: "2022 - 2024",
      descriptions: [
        "⚡ Exchange Student in Image Processing and Computer Vision",
        "⚡ I studied Deep learning, Augmented Reality, 3D Reconstruction, Explainable AI",
      ],
      website_link: "https://www.u-bordeaux.fr/en",
    },
    {
      title: "Autonomous University of Madrid- Spain",
      subtitle: "M.Sc. in Image Processing and Computer Vision",
      logo_path: "uam.png",
      alt_name: "UAM",
      duration: "2022 - 2024",
      descriptions: [
        "⚡ Exchange Student in Image Processing and Computer Vision",
        "⚡ I studied Computer vision, Deep learning",
      ],
      website_link: "https://www.uam.es",
    },
    {
      title: "Pazmany Peter Catholic University- Hungary",
      subtitle: "M.Sc. in Image Processing and Computer Vision",
      logo_path: "ppke.png",
      alt_name: "PPKE",
      duration: "2022 - 2024",
      descriptions: [
        "⚡ M.Sc, Computer Science and Engineering Specialization in Image Processing and Computer Vision",
        "⚡ I studied Basics of Image Processing",
      ],
      website_link: "https://www.ppke.hu",
    },
    {
      title: "Bahir Dar University - Ethiopia",
      subtitle: "M.Sc. in Communication System Engineering",
      logo_path: "bdu.png",
      alt_name: "BDU",
      duration: "2020 - 2022",
      descriptions: [
        "⚡ I have Studied Communication System Engineering",
        "⚡ My research interest has been in millimeter wave radio over fiber",
      ],
      website_link: "https://www.bdu.edu.et",
    },
    {
      title: "Bahir Dar University - Ethiopia",
      subtitle: "B.Sc. in Electrical (Electronics and Communication System) Engineering",
      logo_path: "bdu.png",
      alt_name: "BDU",
      duration: "2013 - 2018",
      descriptions: [
        "⚡ I have studied Electrical Engineering with hand on lab practices",
        "⚡ I have specialized in Electronics and Communication System Engineering ",
      ],
      website_link: "https://www.bdu.edu.et",
    },
  ],
};

// Certificate
const certifications = {
  certifications: [
    // {
    //   title: "Machine Learning",
    //   subtitle: "- Andrew Ng",
    //   logo_path: "stanford_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
    //   alt_name: "Stanford University",
    //   color_code: "#8C151599",
    // },
    // {
    //   title: "Deep Learning",
    //   subtitle: "- Andrew Ng",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "Data Science",
    //   subtitle: "- Alex Aklson",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Big Data",
    //   subtitle: "- Kim Akers",
    //   logo_path: "microsoft_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
    //   alt_name: "Microsoft",
    //   color_code: "#D83B0199",
    // },
    // {
    //   title: "Advanced Data Science",
    //   subtitle: "- Romeo Kienzler",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Advanced ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "DL on Tensorflow",
    //   subtitle: "- Laurence Moroney",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Jogesh Muppala",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    //   alt_name: "Coursera",
    //   color_code: "#2A73CC",
    // },
    // {
    //   title: "Kuberenetes on GCP",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "Cryptography",
    //   subtitle: "- Saurabh Mukhopadhyay",
    //   logo_path: "nptel_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
    //   alt_name: "NPTEL",
    //   color_code: "#FFBB0099",
    // },
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with many companies and research teams.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Doctoral Researcher",
          company: "University of Oulu",
          company_url: "https://oulu.fi",
          logo_path: "uoulu.png",
          alt_name: "UnivOULU",
          duration: "2024 - Present",
          location: "Oulu, Finland",
          description: 
            "Artificial Intelligence and Remote Sensing Technology for Hydrology Model",
          color: "#0879bf",
        },
        {
          title: "Junior Electrical Engineer",
          company: "Ethiopian Electric Utility",
          company_url: "https://eeu.gov.et",
          logo_path: "eeu.png",
          duration: "3.5 Years",
          location: "Bahir Dar, Ethiopia",
          description:
            "I have worked as a junior Electrical Engineer.",
          color: "#0879bf",
        },
        {
          title: "Technology Officer",
          company: "American Space Ethiopia",
          company_url: "https://et.usembassy.gov/",
          logo_path: "usa.jpg",
          duration: "1.5 Years",
          location: "Bahir dar, Ethiopia",
          description:
            "I have organized and managed daily technology events for the youth.",
          color: "#9b1578",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Image Processing and Computer Vision Intern",
          company: "University of Oulu",
          company_url:
            "https://www.oulu.fi",
          logo_path: "uoulu.png",
          duration: "Feb 2024 - July 2024",
          location: "Oulu, Finland",
          description:
            "This intern position is responsible for Hydrology Parameter Estimation from different Imagery Sensors. ",
          color: "#0071C5",
        },
        {
          title: "Operations and Maintenance Engineer Intern",
          company: "Ethiopia Telecommunication",
          company_url: "https://www.etc.gov.et",
          logo_path: "etc.jpg",
          duration: "4 Months.",
          location: "Bahir Dar, Ethiopia",
          description:
            "Operations and Maintenance Engineer Intern was responsible for maintaining the network infrastructure of ETC.",
          color: "#000000",
        },
        {
          title: "Radio and TV Broadcast Engineer Intern",
          company: "Amhara Media Corporation",
          company_url: "https://www.ameco.et/",
          logo_path: "ameco.png",
          duration: "4 Months.",
          location: "Bahir Dar, Ethiopia",
          description:
            "Radio and TV Broadcast Engineer Intern was responsible for TV and Radio broadcast services in the Amhara Region of Ethiopia.",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          "title": "Junior Electrical Engineer",
          "company": "Ethiopian Electric Utility",
          "company_url": "https://www.eeu.gov.et/",
          "logo_path": "eeu.png",
          "duration": "3 Years.",
          "location": " Ethiopia",
          "description": "Help them by Automated File management system.",
          "color": "#33691E"
        },
        {
          "title": "Technology Support Grant",
          "company": "American Spaces Ethiopia",
          "company_url": "https://et.usembassy.gov/",
          "logo_path": "usa.jpg",
          "duration": "1 Year.",
          "location": "Ethiopia",
          "description": "",
          "color": "#1A237E"
        },
        {
          "title": "President",
          "company": "Bahir Dar University Electrical and Computer Engineering Students Association",
          "company_url": "https://www.bdu.edu.et",
          "logo_path": "bdu.png",
          "duration": "1 Year",
          "location": "     Ethiopia",
          "description": "I led the association for 1 year",
          "color": "#FF6F00"
        },
        {
          "title": "Project Supervisor",
          "company": "Bahir Dar University Electrical and Computer Engineering Students Association",
          "company_url": "https://www.bdu.edu.et",
          "logo_path": "bdu.png",
          "duration": "1 year",
          "location": "Ethiopia",
          "description": "I supervise the association projects",
          "color": "#B71C1C"
        },
        // {
        //   "title": "Train Engineer Intern",
        //   "company": "Ethiopian Tele Communication",
        //   "company_url": "etc.gov.et",
        //   "logo_path": "etc.jpg",
        //   "duration": "4 months",
        //   "location": "Bahir Dar, Ethiopia",
        //   "description": "As an intern, I support the maintenance team.",
        //   "color": "#004D40"
        // },
        // {
        //   "title": "Train Engineer Intern",
        //   "company": "Amahara Media Corporation",
        //   "company_url": "https://www.ameco.et/",
        //   "logo_path": "ameco.png",
        //   "duration": "4 months",
        //   "location": "Bahir Dar, Ethiopia",
        //   "description": "as an Intern I gave support to the team.",
        //   "color": "#004D40"
        // },
        // {
        //   "title": "American Space Badges",
        //   "company": "American Space Ethiopia",
        //   "company_url": "https://et.usembassy.gov/",
        //   "logo_path": "usa.jpg",
        //   "duration": "1 year",
        //   "location": "Bahir Dar, Ethiopia",
        //   "description": "I led the technology team",
        //   "color": "#1A237E"
        // }
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I was involved in several research projects that applied image processing and computer vision techniques to solve various problems.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  // title: "Publications",
  // description:
  //   "I have worked on and published a few research papers and publications of my own.",
  // avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "getnet_profile.png",
    description:
      "I am available on almost every social media.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I write personal, technical and some insights around topics.",
    link: "https://medium.com/@getnetdemil/",
    // avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Yliopistokatu 18A, 312, 90570 Oulu, Finland",
    locality: "Oulu",
    country: "FI",
    region: "Oulu",
    postalCode: "90570",
    streetAddress: "Yliopistokatu 18A, 312",
    // avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/Yliopistokatu+16+a+209a,+90570+Oulu/@65.0575366,25.4741151,17z/data=!3m1!4b1!4m5!3m4!1s0x46802dd6618c2acf:0xc9e0b633b2b00eff!8m2!3d65.0575366!4d25.4741151?entry=ttu",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
